export default {
  FETCHED_FOR_ACCOUNT: 'FETCHED_CONTRACT_VALUATIONS_FOR_ACCOUNT',
  FETCHED_FOR_MARKET: 'FETCHED_CONTRACT_VALUATIONS_FOR_MARKET',
};
